import React, { useRef, useEffect } from 'react'
import { checkoutHooks } from '@pff-consumer/data-provider/lib/checkout/checkout.hooks'
import { useFeatureFlags } from '@pff-consumer/feature-flags'
import { SubscriptionPlans } from '@pff-consumer/schema'
import { useSubscribeAnalyticsEvent } from '@pff-consumer/analytics/hooks/useSubscribeAnalyticsEvent'
import { Icon } from '@pff-consumer/tweed-ui/atoms/icon/icon.web'
import { SVGGroup } from '@pff-consumer/utils'
import { SubscriptionPlanTileProps } from './subscription-plan-tile.props'
import { useStyles } from './subscription-plan-tile.styles'

const { useBreakpoints } = checkoutHooks

export const SubscriptionPlanTile = (props: SubscriptionPlanTileProps) => {
  const { type, currency, price, description, description2, plan, planStyle, hasDiscountedPrice, handlePlanClick } =
    props
  const { isDesktop } = useBreakpoints()
  const inputRef = useRef<HTMLInputElement>(null)
  const isTileSelected = type === plan
  const styles = useStyles({ isTileSelected, isDesktop, hasDiscountedPrice })
  const { sendSubscribeAnalyticsEvent } = useSubscribeAnalyticsEvent()
  const { getFeatureFlag } = useFeatureFlags()
  const annualHeadline = getFeatureFlag<string>('subscribe-annual-headline', 'Save $179')

  useEffect(() => {
    inputRef?.current?.focus()
  }, [])

  const handleClick = () => {
    handlePlanClick(type)
    sendSubscribeAnalyticsEvent('Subscription Plan Selected', {
      subscriptionPlanType: type === SubscriptionPlans.PREMIUM_ANNUAL ? 'Annual' : 'Monthly',
      experience: 'Single Page Checkout',
      price: parseFloat(price),
      isTrialIncluded: type === SubscriptionPlans.PREMIUM_ANNUAL,
    })
  }

  return (
    <label className={planStyle}>
      <div className={styles.container}>
        {type === SubscriptionPlans.PREMIUM_ANNUAL ? <div className={styles.trial}>{annualHeadline}</div> : null}

        <div className={styles.radioButtonSVG}>
          {isTileSelected && (
            <Icon
              name='radio-check-blue'
              group={SVGGroup.Icons}
              width={16}
              height={16}
            />
          )}
          {!isTileSelected && (
            <Icon
              name='radio-unchecked'
              group={SVGGroup.Icons}
              width={16}
              height={16}
            />
          )}
          <div className={styles.planName}>
            {type === SubscriptionPlans.PREMIUM_MONTHLY_2024_DRAFT_EARLY ||
            type === SubscriptionPlans.PREMIUM_MONTHLY_2024_DRAFT_PEAK ||
            type === SubscriptionPlans.PREMIUM_MONTHLY_SEASON_PASS ||
            type === SubscriptionPlans.PREMIUM_MONTHLY_SEASON
              ? `Monthly`
              : `Annual`}{' '}
            <input
              type='radio'
              name='subscriptionPlan'
              value={type}
              checked={type === plan}
              className={styles.radioButton}
              onClick={handleClick}
              data-testid={type}
              readOnly
              data-analytics-id={`plan-selector-${type}`}
              ref={inputRef}
            />
          </div>
        </div>

        {type === SubscriptionPlans.PREMIUM_ANNUAL ? (
          <span className={styles.label}>
            {currency}
            {price}{' '}
          </span>
        ) : (
          <span className={styles.label}>
            {currency}
            {price}
          </span>
        )}
        <p className={styles.description}>{description}</p>
        {description2 !== '' ? <p className={styles.description2}>{description2}</p> : null}
      </div>
    </label>
  )
}
